import React from "react";
import { FolderOpen } from "lucide-react";
import Forms from "@/pages/Forms";

export default function Documents() {
  return (
    <div className="p-5 sm:p-8 max-w-[1600px] mx-auto" data-testid="documents-page">
      <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight text-zinc-900 flex items-center gap-2.5">
        <FolderOpen className="h-7 w-7" /> Forms &amp; AI Fill
      </h1>
      <p className="text-sm text-zinc-500 mt-1">Upload &amp; fill PDFs with AI form-fill and auto-mapping. To sign or send for signature, use the E-Sign tab.</p>
      <div className="mt-5"><Forms embedded /></div>
    </div>
  );
}
